module.exports = __webpack_public_path__ + "static/ProximaNova-Bold-2d063fc064cb78905e5a71a65570d3f9.woff";